import { __decorate } from "tslib";
import { css, LitElement, html } from 'lit';
import { property, query, queryAll, state } from 'lit/decorators.js';
import '../../../atom/textarea/element';
import '../../../atom/label/element';
import '../../../atom/paragraph/element';
import '../form-msg/element';
import { CheckErrorMsg } from '../../../../lib/validate/checkErrorMsg';
import { Select } from '../../../../lib/validate/select';
import '../../dropdown/element';
export class FormSelect extends LitElement {
    constructor() {
        super(...arguments);
        this.validator = new Select(this);
        this.disabled = false;
        this.required = false;
        this.multiple = false;
        this.forceRender = false;
        this.requiredInfoText = '* This field is required';
        this.dropdownLabel = 'Select your choice';
        this.loaded = false;
        this.__allReadyRun = false;
        this.getChangeEventListener = (e) => {
            const elm = e.currentTarget;
            this._select.querySelectorAll('option').forEach((item) => {
                if (elm.innerText === item.label) {
                    if (elm.getAttribute('data-value') === 'undefined') {
                        this._select.value = item.value;
                        this.dropdown.value = elm.innerText;
                        this.value = '';
                        this.removeAttribute('selected');
                        this.dropdown.labelElement.classList.remove('value');
                        this.dropdown.closeWithClick();
                        return;
                    }
                    this.setAttribute('selected', '');
                    item.selected = true;
                    this.value = item.value;
                    this._select.value = item.value;
                    this.dropdown.value = elm.innerText;
                    this.dropdown.closeWithClick();
                    return;
                }
            });
            //this.getValue()
            this.change();
        };
        this.slotChangeEventListener = (e) => {
            e.stopImmediatePropagation();
            e.stopPropagation();
            this._updateItems();
            if (this._select.scrollHeight > this._select.clientHeight) {
                this._select.classList.add('scrollable');
                return;
            }
            this._select.classList.remove('scrollable');
        };
    }
    render() {
        return html `
            <div style="display: none">
                <slot></slot>
            </div>
            <div class="select">
                <select @change="${this.change}"></select>
                <ep-label>${this.label}</ep-label>
            </div>
            <span class="focus"></span>
            <ep-form-msg></ep-form-msg>
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this._slotItem.addEventListener('slotchange', this.slotChangeEventListener);
        if (!this.hasAttribute('multiple')) {
            setTimeout(() => {
                for (let i = 0; i < this._select.options.length; i++) {
                    if (this._select.options[i].hasAttribute('selected')) {
                        if (this._select.options[i].value === ' ' || this._select.options[i].value === undefined) {
                            this._select.options[i].classList.add('empty');
                        }
                        this.dropdown.value = this._select.options[i].label;
                        this.value = this._select.options[i].value;
                        this.getValue();
                    }
                }
            }, 0);
        }
        if ((this.value !== undefined && this.value !== null && this.value !== '') || this.hasAttribute('multiple')) {
            setTimeout(() => {
                this.getValue();
                this.__allReadyRun = true;
            }, 100);
        }
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.infoText !== undefined && !this.hasAttribute('required')) {
            this._formMsg.infoText = this.infoText;
        }
        if (this.hasAttribute('required')) {
            this.watchRequired();
            this.validator = new Select(this, this.requiredErrorMsg ? this.requiredErrorMsg : '');
        }
        if (this.size !== undefined)
            this._select.setAttribute('size', String(this.size));
        if (this.dropdown && this.dropdown.hasAttribute('disabled')) {
            this.dropdown.removeAttribute('disabled');
        }
        if (this.hasAttribute('disabled') && !this.hasAttribute('multiple')) {
            if (this.dropdown)
                this.dropdown.setAttribute('disabled', '');
        }
        if (this.hasAttribute('multiple')) {
            this.multiple = true;
            this._select.setAttribute('multiple', '');
            this.classList.add('multiple');
        }
        if (this.hasAttribute('not-valid'))
            this._select.setAttribute('not-valid', '');
        if (!this.hasAttribute('not-valid'))
            this._select.removeAttribute('not-valid');
        if ((_changedProperties === null || _changedProperties === void 0 ? void 0 : _changedProperties.has('value')) && this.__allReadyRun) {
            this.getValue();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._slotItem)
            this._slotItem.removeEventListener('slotchange', this.slotChangeEventListener);
    }
    defineFor() {
        this._labelItem.setAttribute('for', this.name);
        this._select.setAttribute('id', this.name);
        this._select.setAttribute('name', this.name);
    }
    watchRequired() {
        var _a;
        this.setAttribute('required', '');
        if (!((_a = this.infoText) === null || _a === void 0 ? void 0 : _a.includes(`${this.requiredInfoText}`)) && this.infoText !== undefined) {
            this.infoText = `${this.requiredInfoText} <br/> ${this.infoText}`;
            this._formMsg.infoText = this.infoText;
        }
        if (this.infoText === undefined) {
            this.infoText = `${this.requiredInfoText}`;
            this._formMsg.infoText = this.infoText;
        }
    }
    _updateItems() {
        const template = document.createDocumentFragment();
        const items = [];
        this._slotItem.assignedElements().forEach((item) => {
            if (this.hasAttribute('multiple')) {
                template.append(item);
            }
            else {
                template.append(item.cloneNode(true));
            }
            const it = item;
            items.push({ label: it.label, value: it.value });
        });
        this._select.append(template);
        this.loaded = true;
        this.defineFor();
        this.updated();
        if (!this.hasAttribute('multiple')) {
            if (this.dropdown) {
                this.dropdown.remove();
                this._spans.forEach((span) => {
                    span.remove();
                });
            }
            const dropdown = document.createElement('ep-dropdown');
            this.select.style.setProperty('display', 'none');
            dropdown.label = this.label;
            if (this.hasAttribute('required') && !this.hasAttribute('noafter'))
                dropdown.label += '*';
            if (!this.forceRender && items.length === 0)
                return;
            items.forEach((item) => {
                const elm = document.createElement('span');
                elm.innerText = item.label;
                elm.setAttribute('slot', 'body');
                elm.setAttribute('data-value', item.value);
                elm.addEventListener('click', this.getChangeEventListener);
                if (item.value === ' ' || item.value === 'undefined') {
                    elm.classList.add('empty');
                }
                dropdown.append(elm);
            });
            if (this.value)
                dropdown.value = this.value;
            dropdown.tabIndex = this.disabled ? -1 : 1;
            this.dropdown = dropdown;
            this.shadowRoot.prepend(dropdown);
            setTimeout(() => {
                if (this.dropdown && this.dropdown.slotBody) {
                    this._spans = this.dropdown.slotBody.assignedElements();
                }
            }, 100);
        }
    }
    change() {
        if (!this.multiple)
            this.value = this._select.value ? this._select.value : '';
        this.getValue();
        new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
    }
    getValue(noChange) {
        const value = [];
        if (this.multiple) {
            if (this._select.selectedOptions.length > 0) {
                for (let i = 0; i < this._select.selectedOptions.length; i++) {
                    value.push(this._select.selectedOptions[i].value);
                }
            }
            this.value = String(value);
            this.dispatchEvent(new CustomEvent('change', {
                composed: true,
                detail: this.value
            }));
            return;
        }
        if (this.value !== ' ' && this.value !== 'undefined' && this.value !== null) {
            this._select.value = String(this.value);
            if (this.dropdown)
                this.dropdown.value = String(this.value);
            this._spans = this.dropdown.slotBody.assignedElements();
            this._spans.forEach((span) => {
                if (span.getAttribute('data-value') === String(this.value)) {
                    this.dropdown.value = span.innerText;
                }
            });
            this.setAttribute('selected', '');
        }
        if (this.value === ' ' || this.value === 'undefined' || this.value === null) {
            this._select.value = '';
            if (this.dropdown) {
                this.dropdown.value = '';
            }
        }
        if (noChange)
            return;
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: this.value
        }));
    }
    reset() {
        this.value = '';
        this._select.value = '';
        if (this.dropdown) {
            this.dropdown.value = '';
            this.dropdown.removeAttribute('value');
            this.dropdown.labelElement.classList.remove('value');
        }
        this.removeAttribute('not-valid');
        this._formMsg.errorP.style.display = 'none';
    }
}
FormSelect.styles = css `
        :host {
            position: relative;
            display: block;
        }

        :host(:focus-visible),
        option:focus-visible,
        select:focus-visible {
            outline: 0;
        }

        :host([not-valid]) select {
            border-color: var(--ep-color-danger);
        }

        .select {
            position: relative;
            display: grid;
            grid-template-areas: 'select';
            align-items: center;
        }

        ::slotted(*) {
            display: none;
        }

        ep-label {
            display: inline-block;
            position: absolute;
            pointer-events: none;
            left: 5px;
            top: -9px;
            --ep-text-font-size: 14px;
            background-color: var(--ep-color-white);
            padding: 0 10px;
            transition: 0.2s ease all;
            -moz-transition: 0.2s ease all;
            -webkit-transition: 0.2s ease all;
        }

        :host(.multiple) ep-label {
            left: 5px;
            top: -9px;
            --ep-text-font-size: 14px;
            background-color: var(--ep-color-white);
            padding: 0 10px;
        }

        *,
        *::before,
        *::after {
            box-sizing: border-box;
        }

        :host([required]) ep-label:after {
            content: '*';
            font-size: 12px;
            vertical-align: top;
            color: var(--ep-label-text-color);
        }

        :host([noAfter]) ep-label:after {
            display: none;
        }

        select {
            appearance: none;
            background-color: transparent;
            border: none;
            margin: 0;
            cursor: inherit;
            width: 100%;
            display: inline-block;
            line-height: 22px;
            padding: 5px 5px 5px 13px;
            font-size: var(--ep-select-text-font-size, 14px);
            color: var(--ep-select-text-color, var(--ep-text-color));
            border: var(--ep-select-border, 2px solid var(--ep-color-tertiary));
            border-radius: var(--ep-select-border-radius, 3px);
            outline: none;
        }

        select[multiple] {
            height: auto;
        }

        select.scrollable {
            padding-right: var(--ep-select-scrollable-padding-right, 10px);
        }

        select.scrollable,
        select[multiple],
        select[size] {
            vertical-align: middle;
        }

        option {
            padding: var(--ep-select-option-padding, 5px 10px);
        }

        select.focus ~ ep-label {
            --ep-label-text-color: var(--ep-color-primary);
        }

        select[not-valid] ~ ep-label {
            --ep-label-text-color: var(--ep-color-danger);
        }

        .select::after {
            content: '';
            width: 0.8em;
            height: 0.5em;
            margin-right: 15px;
            justify-self: end;
            background-color: var(--ep-color-tertiary);
            clip-path: polygon(100% 0%, 0 0%, 50% 100%);
        }

        select,
        .select:after {
            grid-area: select;
        }

        select:focus + .focus {
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            border: 2px solid var(--ep-color-primary);
            border-radius: inherit;
        }

        select:disabled,
        :host([disabled]) ep-dropdown {
            background-color: var(--ep-color-gray-3);
            cursor: not-allowed !important;
        }

        :host([multiple]) .select:after {
            display: none;
        }

        select option:checked {
            background-color: var(--ep-color-primary);
            color: white;
        }

        ep-dropdown {
            --ep-dropdown-width: var(--ep-select-width, calc(100%));
        }

        :host([not-valid]) ep-dropdown {
            --ep-dropdown-border-color: var(--ep-color-danger);
            --ep-label-text-color: var(--ep-color-danger);
            color: var(--ep-color-danger);
        }

        .empty {
            height: 24px;
        }

        @media only screen and (max-width: 500px) {
            grid-template-columns: var(--ep-select-grid-columns-sm, 100%);
        }

        @media only screen and (min-width: 500px) and (max-width: 800px) {
            grid-template-columns: var(--ep-select-grid-columns-md, 50% 50%);
        }
    `;
__decorate([
    property()
], FormSelect.prototype, "name", void 0);
__decorate([
    property()
], FormSelect.prototype, "label", void 0);
__decorate([
    property()
], FormSelect.prototype, "infoText", void 0);
__decorate([
    property({ type: Boolean })
], FormSelect.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], FormSelect.prototype, "required", void 0);
__decorate([
    property()
], FormSelect.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], FormSelect.prototype, "multiple", void 0);
__decorate([
    property({ type: Boolean })
], FormSelect.prototype, "forceRender", void 0);
__decorate([
    property({ type: Number })
], FormSelect.prototype, "size", void 0);
__decorate([
    property()
], FormSelect.prototype, "requiredErrorMsg", void 0);
__decorate([
    property()
], FormSelect.prototype, "requiredInfoText", void 0);
__decorate([
    property()
], FormSelect.prototype, "dropdownLabel", void 0);
__decorate([
    query('ep-label')
], FormSelect.prototype, "_labelItem", void 0);
__decorate([
    query('select')
], FormSelect.prototype, "_select", void 0);
__decorate([
    query('slot')
], FormSelect.prototype, "_slotItem", void 0);
__decorate([
    query('ep-form-msg')
], FormSelect.prototype, "_formMsg", void 0);
__decorate([
    query('.select')
], FormSelect.prototype, "select", void 0);
__decorate([
    state()
], FormSelect.prototype, "_spans", void 0);
__decorate([
    queryAll('span[slot=body]')
], FormSelect.prototype, "_slotItems", void 0);
if (!customElements.get('ep-form-select')) {
    customElements.define('ep-form-select', FormSelect);
}
//# sourceMappingURL=element.js.map